import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../../common/components";
import './filter-options-text.scss';

const IndustryFilter: any = (
  props: any
) => {
  const { industry, handleIndustryChange, isIndustryEnabled, industryError } = props
  useEffect(() => {
    if (!isIndustryEnabled) {
      handleIndustryChange({ target: { value: "", name: "industry" } } as any, "industry");
    }
  }, [isIndustryEnabled]);
  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          industry: industry,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="industry"
            placeholder="Enter Industry"
            optional={false}
            disabled={false}
            value={industry}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleIndustryChange(e, "industry")
            }
          />
          {industryError && <div className="error-text">{industryError}</div>}
        </Form>
      </Formik>
    </div>

  );
};
export default IndustryFilter;